import { SeriesOverlay, MovieOverlay } from '../overlay'

export const getOverlayComponent = tile => {
  switch (tile.contentItem.__typename) {
    case 'Title':
      return MovieOverlay
    case 'Series':
      return SeriesOverlay
    default:
      console.error(
        `
        ----------------------------------------------------
        unknown overlay type, ${tile.contentItem.__typename}
        resolve this issue BEFORE release!
        ----------------------------------------------------`
      )
      return 'div'
  }
}
